(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('inlinePolicyDao', ["$q", "http", "modulesManager", function ($q, http, modulesManager) {
        var inlinePolicyDao = {
            retrieveConfig: function (module) {
                module = module || modulesManager.currentModule();
                return http.get('api/v1/' + module + '/inline_users').onRequestFail(function (input) {
                    return $q.when({ data: { rows: [] } });
                });
            }
        };
        return inlinePolicyDao;
    }]);
}());